import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import type { GateStatus } from '~/app/gate';
import { Require } from '~/app/require';

/** Setup's pages: after the app language, for a first workspace and for a new one beside it. */
const SETUP: readonly GateStatus[] = ['needs-onboarding', 'signed-in'];
/** The app language: before setup, and open again to a person who comes back to it. */
const LANGUAGE: readonly GateStatus[] = ['needs-language', ...SETUP];

function OnboardingGate(): ReactElement {
  const onLanguage = useLocation({ select: (location) => location.pathname === '/onboarding/language' });
  return (
    <Require allow={onLanguage ? LANGUAGE : SETUP}>
      <Outlet />
    </Require>
  );
}

/**
 * Setup. For a person with no business yet, who chooses the app language
 * first, and for a signed-in person making a second one: the phone mounts the
 * same screens for both.
 */
export const Route = createFileRoute('/onboarding')({
  component: OnboardingGate,
});
